import {
  CloseIcon,
  ExcelIconV2,
  ExclamationCirlce,
  PdfIconV2,
} from "../../../../assets/svgIcons";
import primaryComponents from "../../../primaryComponents";
import secondaryComponents from "../..";
import Icon from "../../../../assets/icons";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";

const DownloadModal = ({
  setIsDownloadReport,
  downloadEndOfDay,
  closeModal,
}) => {
  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <h6 className="text-center font-weight-semibold mb-0">
          Advanced End of Day
        </h6>
        <CloseIcon style={{ fontSize: "25px" }} onClick={closeModal} />
      </div>

      <hr style={{ marginLeft: "-13px", marginRight: "-13px" }} />

      <div
        className={`${globalStyles.cardWithBackground} card-plain text-center`}
        style={{ gap: "20px" }}
      >
        <div>
          <p className="smallest-text-size dark--text mb-1">
            Select the format you want to download
          </p>
          <div className={styles.infoMessage}>
            <ExclamationCirlce
              stroke="black"
              width="22"
              height="22"
              className="mr-2"
            />
            <p className="smallest-text-size dark--text">
              Click download will first generate your end of day before it
              automatically downloads.
            </p>
          </div>
        </div>

        <div className={styles.formatOptions}>
          <div>
            <div className={styles.formatOption}>
              <PdfIconV2 />
            </div>

            <div
              className="d-flex align-items-center justify-content-between"
              style={{ gap: "5px" }}
            >
              <primaryComponents.Button
                onClick={() => {
                  setIsDownloadReport(true);
                  downloadEndOfDay({
                    delivery_method: "download",
                    download_format: "pdf",
                  });
                }}
                classNames="btn btn--primary cover smallBtn"
              >
                Download Full Summary
              </primaryComponents.Button>
              <secondaryComponents.ToolTipV2
                tipText="Send to Email"
                position="left"
              >
                <primaryComponents.Button
                  onClick={() =>
                    downloadEndOfDay({
                      delivery_method: "send_to_email",
                      download_format: "pdf",
                    })
                  }
                  classNames="btn btn--outline"
                  style={{ height: "30px", width: "20px" }}
                >
                  <img src={Icon.emailTwo} alt="" />
                </primaryComponents.Button>
              </secondaryComponents.ToolTipV2>
            </div>
          </div>
          <div>
            <div className={styles.formatOption}>
              <ExcelIconV2 />
            </div>
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ gap: "5px" }}
            >
              <primaryComponents.Button
                onClick={() => {
                  setIsDownloadReport(true);
                  downloadEndOfDay({
                    delivery_method: "download",
                    download_format: "excel",
                  });
                }}
                classNames="btn btn--primary cover smallBtn"
              >
                Download Full Summary
              </primaryComponents.Button>
              <secondaryComponents.ToolTipV2
                tipText="Send to Email"
                position="left"
              >
                <primaryComponents.Button
                  onClick={() =>
                    downloadEndOfDay({
                      delivery_method: "send_to_email",
                      download_format: "excel",
                    })
                  }
                  classNames="btn btn--outline cover"
                  style={{ height: "30px", width: "20px" }}
                >
                  <img src={Icon.emailTwo} alt="" />
                </primaryComponents.Button>
              </secondaryComponents.ToolTipV2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;
